import { getNumberedEnv, isHostNumberedEnv } from "@utils/url-utils";

export const appVersion: string = "1.0.0-feature-ST-3287-Move-company-related-types-and-routes-to-CoreApiClient.3";
export const appTimestamp: string = "2025-07-02T15:18:14.000Z";
export const commitId: string = "4186170c519d48777de918f38b36d816f89f22a7";
export const commitUrl: string = "https://dev.azure.com/faro-connect/Stellar/_git/Dashboard/commit/4186170c519d48777de918f38b36d816f89f22a7?refName=refs%2Fheads%2Fmaster";
export const pullRequestId: string = "34395";
export const pullRequestUrl: string = "https://dev.azure.com/faro-connect/Stellar/_git/Dashboard/pullrequest/34395";
export const jiraTicketId: string = "ST-3287";
export const jiraTicketUrl: string = "https://faro01.atlassian.net/browse/ST-3287";

export const sentryDSNKey =
  "https://c9b011b3368bc41e188fcbae7fb7a872@o381590.ingest.sentry.io/4505674738499584";
export const localizeKey = "iKNI0OJMw3RLe";
export const muiProKey =
  "3d69a08fc3c9d75a1ff22bebf8fcfd23Tz05NjEyMyxFPTE3NTUyNDI3NzUwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPWluaXRpYWwsS1Y9Mg==";
export const amplitudeStagingKey = "6669713f5f821a32accec4f56cde20d9";
export const amplitudeProdKey = "0f55bafc3d3b678c50ca73a88964be8a";

export const procoreApiUrlStaging = "https://sandbox.procore.com/rest/v1.0";
export const procoreApiUrlProduction = "https://api.procore.com/rest/v1.0";
export const autodeskApiUrl = "https://developer.api.autodesk.com/project/v1";

export const isNumberedEnv = isHostNumberedEnv(globalThis.location.host);
export const numberedEnv = isNumberedEnv
  ? getNumberedEnv(globalThis.location.host)
  : null;

/** Intercom App Id to use in the development environments (both dev and staging) */
export const intercomAppIdDev = "ufxujusd";

/** Intercom App Id to use in the production environments */
export const intercomAppIdProd = "cuydqq3r";

/** Stripe publishable key of sandbox account to use in testing environments */
export const stripePublishableKeySandbox =
  "pk_test_51QuD8AFLTUPWWL4xi1B8qpBlhcyEtIXTGXvWB7Lc0zxobs8ZfTuLhnnfP0ogSnMKEP0rF8x0bS59PiZa7uvgL4a000vUShz0OP";

// TODO: Add the production key for stripe https://faro01.atlassian.net/browse/ST-2925
/** Stripe publishable key of production account to use in production environments */
export const stripePublishableKeyProduction = "";
